/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} True_Teal_Swan_PlotInputs */

const en_true_teal_swan_plot = /** @type {(inputs: True_Teal_Swan_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a language`)
};

const de_true_teal_swan_plot = /** @type {(inputs: True_Teal_Swan_PlotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Sprache aus`)
};

/**
* | output |
* | --- |
* | "Please select a language" |
*
* @param {True_Teal_Swan_PlotInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const true_teal_swan_plot = /** @type {((inputs?: True_Teal_Swan_PlotInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<True_Teal_Swan_PlotInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_true_teal_swan_plot(inputs)
	return de_true_teal_swan_plot(inputs)
});